module.exports = __webpack_public_path__ + "img/Sedan_Front_Side_Right_Transparent.7124c94e.svg";